export class Company {

    private readonly _id: string;
    private readonly _europeanVatNumber: string;
    private readonly _companyName: string;
    private readonly _internationalCompanyName: string;
    private readonly _address: string;
    private readonly _postcode: string;
    private readonly _city: string;
    private readonly _country: string;

    constructor(id: string, europeanVatNumber: string, companyName: string, internationalCompanyName: string, address: string, postcode: string, city: string, country: string) {
        this._id = id;
        this._europeanVatNumber = europeanVatNumber;
        this._companyName = companyName;
        this._internationalCompanyName = internationalCompanyName;
        this._address = address;
        this._postcode = postcode;
        this._city = city;
        this._country = country;
    }

    get id(): string {
        return this._id;
    }

    get europeanVatNumber(): string {
        return this._europeanVatNumber;
    }

    get companyName(): string {
        return this._companyName;
    }

    get internationalCompanyName(): string {
        return this._internationalCompanyName;
    }

    get address(): string {
        return this._address;
    }

    get postcode(): string {
        return this._postcode;
    }

    get city(): string {
        return this._city;
    }

    get country(): string {
        return this._country;
    }

}
